import { getSafeRedirectUrl } from "./safeRedirect";
import { showCheckoutRecovery } from "./checkoutRecovery";

/**
 * Long enough that a slow provider redirect is not mistaken for a failure,
 * short enough that a buyer staring at a spinner gets an answer.
 */
const STUCK_AFTER_MS = 4000;

/**
 * Sends the buyer to the payment provider, and notices when that does not
 * happen.
 *
 * Some in-app browsers silently discard navigations and app-switches, leaving
 * the buyer on a page that never changes. Rather than guessing which apps those
 * are from the user agent — a list that is wrong in both directions and has to
 * be maintained against other people's release cycles — observe whether we
 * actually left: a real navigation tears this page down, and an app-switch
 * hides it first. If neither happened, the payment did not start.
 */
export const navigateToCheckout = (
    url: string,
    onStuck?: () => void
): boolean => {
    const safeUrl = getSafeRedirectUrl(url);
    if (safeUrl === null) {
        console.error("Blocked redirect to unsafe URL:", url);
        return false;
    }

    let leftThePage = false;
    const markLeft = () => {
        leftThePage = true;
    };
    const onVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
            markLeft();
        }
    };

    window.addEventListener("pagehide", markLeft);
    document.addEventListener("visibilitychange", onVisibilityChange);

    window.setTimeout(() => {
        window.removeEventListener("pagehide", markLeft);
        document.removeEventListener("visibilitychange", onVisibilityChange);
        if (leftThePage) {
            return;
        }
        showCheckoutRecovery(safeUrl);
        if (onStuck) {
            onStuck();
        }
    }, STUCK_AFTER_MS);

    window.location.href = safeUrl;
    return true;
};
